import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {ifloorplanStateAdd} from '../redux/actions/actions';

const EditButtonLabel = (props) => {
    const ifloorplanObj = props.ifloorplanNowState;
    const buttonMarkerObj = props.image_key >=0 ? props.ifloorplanNowState.level[props.levelNowId].images[props.image_key] :
                props.ifloorplanNowState.level[props.levelNowId].panelum[props.pannellum_key];
    const [text, setText] = useState();
    const [textSize, setSize] = useState([1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6]);

    const [inputStyle, setInputStyle] = useState({
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontSize: `2vh`,
        fontFamily: 'Roboto, sans-serif',
        color: '#000',
    });

    const [opacitySize, setOpacitySize] = useState('none');
    const [opacityFont, setOpacityFont] = useState('none');
    const [isBlockVisible, setBlockVisible] = useState(false); //is text editor block visible or not
    const fontFamily = {
        'IBM Plex Serif, serif': 'IBM Plex Serif',
        'Roboto, sans-serif': 'Roboto',
        'DM Sans, sans-serif': 'DM Sans',
        'Verdana, Arial, Helvetica, sans-serif': 'Arial',
        'Lucida Console, Courier, monospace': 'Courier',
        'cursive': 'Cursive',
        'fantasy': 'Fantasy',
    }

    useEffect(() => {
        if (buttonMarkerObj) {
            setInputStyle({
                fontWeight: buttonMarkerObj.button_font_weight,
                fontStyle: buttonMarkerObj.button_font_style,
                fontSize: `${buttonMarkerObj.button_font_size}vh`,
                fontFamily: buttonMarkerObj.button_font_family,
                color: buttonMarkerObj.button_color_text ? 
                    buttonMarkerObj.button_color_text : '#000',
            });
            setText(buttonMarkerObj.button_label);
        }
    }, [])

    const changeFont = (value) => {
        setInputStyle({
            ...inputStyle,
            fontFamily: value,
        })
        setOpacityFont("none");
    }

    const changeSize = (value) => {
        setInputStyle({
            ...inputStyle,
            fontSize: `${value}vh`,
        })
        setOpacitySize("none");
    }

    const handleChange = (event) => {
        if (isBlockVisible)
            setText(event.target.value);
    }
    const Save = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        if (props.image_key >= 0) {
            newState.level[props.levelNowId].images[props.image_key].button_label = text;
            newState.level[props.levelNowId].images[props.image_key].button_color_text = inputStyle.color;
            newState.level[props.levelNowId].images[props.image_key].button_font_family = inputStyle.fontFamily;
            newState.level[props.levelNowId].images[props.image_key].button_font_size = parseFloat(inputStyle.fontSize);
            newState.level[props.levelNowId].images[props.image_key].button_font_style = inputStyle.fontStyle;
            newState.level[props.levelNowId].images[props.image_key].button_font_weight = inputStyle.fontWeight;
        }
        else if (props.pannellum_key >= 0){
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_label = text
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_color_text = inputStyle.color
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_font_family = inputStyle.fontFamily
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_font_size = parseFloat(inputStyle.fontSize)
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_font_style = inputStyle.fontStyle
            newState.level[props.levelNowId].panelum[props.pannellum_key].button_font_weight = inputStyle.fontWeight
        }

        props.ifloorplanStateAdd(newState);
    }

    useEffect(() => {
        Save();
    }, [inputStyle, text])

    return (
        <div className='edit-button-label-block'>
            <div className="wrap_label_editor_main"
                 style={{display: isBlockVisible ? "block" : "none"}}>
                <div className='edit-label-wrapper'>
                    <div className='font-style'>
                        <ul style={{
                            display: opacityFont,
                        }}>
                            {Object.entries(fontFamily).map((key, value) => {
                                return (<li style={{outline: inputStyle.fontFamily===key[0] ? "solid 1px" : "none"}} onClick={() => {changeFont(key[0])}}>{key[1]}</li>)
                            })}
                        </ul>
                        <div onClick={() => setOpacityFont(opacityFont === 'none' ? 'block' : 'none')}>
                            {fontFamily[inputStyle.fontFamily]}
                            <i className="fas fa-caret-down"></i>
                        </div>
                    </div>

                    <div className='font-size'>
                        <ul style={{
                            display: opacitySize,
                        }}>
                            {textSize.map(size => {
                                return (
                                    <li style={{ outline: size===parseFloat(inputStyle.fontSize) ? "solid 1px" : "none"}} key={size} onClick={() => changeSize(size)}> {size} </li>
                                ) 
                            })}
                        </ul>
                        <div onClick={() => setOpacitySize(opacitySize === 'none' ? 'block' : 'none')}>
                            <i className="fas fa-text-height"></i>
                            <i className="fas fa-caret-down"></i>
                        </div>
                        
                    </div>

                    <div className={inputStyle.fontWeight === 'bold' ? 'bold-style active' : 'bold-style'}
                         onClick={() => {
                             setInputStyle({
                                ...inputStyle,
                                fontWeight: inputStyle.fontWeight === 'bold' ? 'normal' : 'bold'
                            });
                        }}>
                        <i className="fas fa-bold"></i>
                    </div>
                    <div className={inputStyle.fontStyle === 'italic' ? 'italic-style active' : 'italic-style'}
                         onClick={() => {
                             setInputStyle({
                                ...inputStyle,
                                fontStyle: inputStyle.fontStyle === 'italic' ? 'normal' : 'italic'
                            });
                        }}>
                        <i className="fas fa-italic"></i>
                    </div>
                    <div style={{border: "none"}}>
                        <input type="color" value={inputStyle.color}
                            onChange={(e)=> {
                                setInputStyle({
                                    ...inputStyle,
                                    color: e.target.value,
                                });
                            }}/>
                    </div>
                    <div
                        onClick={() => {
                            setBlockVisible(false);
                            document.getElementsByClassName("wrap_text_editor_main")[0].style.display = "none";
                        }}>
                        Done
                    </div>

                </div>
            </div>

            <form>
                <input id="text_input" 
                    style={{
                        border: "1px solid #80808066",
                        cursor: isBlockVisible ? "auto" : "all-scroll",
                        caretColor: isBlockVisible ? "auto" : "rgba(0,0,0,0)",
                    }}
                    type='text'
                    value={text}
                    placeholder='Type button label here'
                    onChange={handleChange}
                    autoComplete="off"
                    onClick={() => {
                        setBlockVisible(true)
                    }}
                />
            </form>
        </div>
    )
}

const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        image_key: state.image_key,
        pannellum_key: state.pannellum_key,
    }
}

const putActions = (dispatch) => {
    return {
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan))
    }
}

export default connect(putState, putActions)(EditButtonLabel);